import type { ActivityEntry, RegionShare, Stat } from '@/models'

import { CARDS } from './game-config'

export const STATS: Stat[] = [
  { id: 's1', label: 'Daily active', value: '412,880', delta: '+3.2%', up: true, live: true },
  { id: 's2', label: 'Concurrent', value: '38,410', delta: '+1.1%', up: true, live: true },
  { id: 's3', label: 'IAP today', value: '$61,204', delta: '−4.8%', up: false },
  { id: 's4', label: 'Crash-free', value: '99.62%', delta: '+0.07%', up: true },
]

/** 30 days of DAU, deterministic so the chart does not jitter between reloads. */
export const DAU_SERIES: number[] = Array.from({ length: 30 }, (_, i) =>
  Math.round(360_000 + Math.sin(i / 3.2) * 28_000 + i * 2_100 + ((i * 977) % 9_000)),
)

export const ACTIVITY: ActivityEntry[] = [
  { id: 'a1', who: 'Mira Kang', what: 'published config to production', ago: '12m ago' },
  { id: 'a2', who: 'Dev Bot', what: 'started build android 1.0.9', ago: '48m ago' },
  { id: 'a3', who: 'Tomas R.', what: 'banned player VoltGoblin', ago: '2h ago' },
  { id: 'a4', who: 'Mira Kang', what: 'created gift code GOLDRUSH26', ago: '5h ago' },
  { id: 'a5', who: 'Ana P.', what: 'edited Storm Colossus damage', ago: '1d ago' },
]

export const TOP_CARDS = [...CARDS].sort((a, b) => b.usage - a.usage).slice(0, 5)

export const REGIONS: RegionShare[] = [
  { id: 'r1', region: 'North America', players: '128,400', share: 31 },
  { id: 'r2', region: 'Europe', players: '112,910', share: 27 },
  { id: 'r3', region: 'Asia', players: '98,240', share: 24 },
  { id: 'r4', region: 'LATAM', players: '49,610', share: 12 },
  { id: 'r5', region: 'Other', players: '23,720', share: 6 },
]
